import store from "@/store/index";
import {post} from "@/plugins/axios";

/*
 * 协调中心机构添加/修改
 * @constructor jack
 * */
export const updateXie = (org_name, org_code, username, phone, email, region_text, address, remark, longitude, latitude, shen_type, u_token = store.state.token2) => post("/org/updateXie", {
  org_name, org_code, username, phone, email, region_text, address, remark, longitude, latitude, shen_type, u_token
});



/*
* 实习基地列表
* @constructor jack
* */
export const getSxStatistics = ( u_token = store.state.token2) => post("/org/xt5_statistics", {
  u_token
})


/*
* 实习基地列表
* @constructor jack
* */
export const xieOrg5list = (page, list_rows, org_name, u_token = store.state.token2) => post("/org/xieOrg5list", {
  page,
  list_rows,
  org_name,
  u_token
})

/*
* 实习基地岗位列表
* @constructor jack
* */
export const xieStationList = (org_id, type, u_token = store.state.token2) => post("/org/xieStationList", {
  org_id, type, u_token
})

/*
* 实习基地岗位下的审核列表
* @constructor jack
* */
export const xietiaoVolunteer = (org_id, level, sx_id, page, list_rows, u_token = store.state.token2) => post("/org/xietiaoVolunteer", {
  org_id, level, sx_id, page, list_rows, u_token
})

/*
* 实习基地学生的审核
* @constructor jack
* */
export const xietiaoVolunteerStatus = (zy_id, status, u_token = store.state.token2) => post("/org/xietiaoVolunteerStatus", {
  zy_id, status, u_token
})

/*
* 实习学生列表
* @constructor jack
* */
export const xietiao5Student = (stu_name, status, sx_id, page, list_rows, u_token = store.state.token2) => post("/org/xietiao5Student", {
  stu_name, status, sx_id, page, list_rows, u_token
})

/*
* 培训/教学 考试列表
* @constructor jack
* */
export const xieExamList = (page, list_rows, exam_name, u_token = store.state.token2) => post("/org/xieExamList", {
  page, list_rows, exam_name, u_token
})

/*
* 培训/教学 考试机构报名列表
* @constructor jack
* */
export const xieExamOrgList = (exam_id, page, list_rows, org_name, u_token = store.state.token2) => post("/org/xieExamOrgList", {
  exam_id, page, list_rows, org_name, u_token
})

/*
* 培训/教学 考试报名列表
* @constructor jack
* */
export const xieExamStuList = (exam_id, page, list_rows, org_id, stu_name, stu_phone, stu_idcard, state, u_token = store.state.token2) => post("/org/xieExamStuList", {
  exam_id, page, list_rows, org_id, stu_name, stu_phone, stu_idcard, state, u_token
})

/*
* 培训/教学协调中心 审核报名学生
* @constructor jack
* */
export const setStateOne = (id, state, reason, u_token = store.state.token2) => post("/org/setStateOne", {
  id, state, reason, u_token
})


/*
* 考场协调中心 考试列表
* @constructor jack
* */
export const xieRoomExamList = (page, list_rows, exam_name, u_token = store.state.token2) => post("/org/xieRoomExamList", {
  page, list_rows, exam_name, u_token
})

/*
* 考场协调中心 考试报名列表
* @constructor jack
* */
export const xieRoomExamStuList = (exam_id, page, list_rows, org_id, stu_name, stu_phone, stu_idcard, state, u_token = store.state.token2) => post("/org/xieRoomExamStuList", {
  exam_id, page, list_rows, org_id, stu_name, stu_phone, stu_idcard, state, u_token
})

/*
* 考场协调中心 考试机构报名列表
* @constructor jack
* */
export const xieRoomExamOrgList = (exam_id, page, list_rows, org_name,  u_token = store.state.token2) => post("/org/xieRoomExamOrgList", {
  exam_id, page, list_rows, org_name,  u_token
})

/*
* 考场协调中心 审核报名学生
* @constructor jack
* */
export const setStateTwo = (id, state, reason, u_token = store.state.token2) => post("/org/setStateTwo", {
  id, state, reason, u_token
})

/*
* 考场协调中心 获取可更改考试
* @constructor jack
* */
export const getChangeExam = (exam_id, u_token = store.state.token2) => post("/org/getChangeExam", {
    exam_id, u_token
})

/*
* 考场协调中心 更改考试
* @constructor jack
* */
export const xieChangeExam = (id,exam_id, org_id, u_token = store.state.token2) => post("/org/xieChangeExam", {
    id,exam_id, org_id, u_token
})

/*
* 考场协调中心 获取可更改考场
* @constructor jack
* */
export const getChangeRoom = (exam_id, org_id, u_token = store.state.token2) => post("/org/getChangeRoom", {
    exam_id, org_id, u_token
})

/*
* 考场协调中心 更改考场
* @constructor jack
* */
export const xieChangeRoom = (id, org_id, u_token = store.state.token2) => post("/org/xieChangeRoom", {
    id, org_id, u_token
})


/*
* 教学协调中心 -机构列表
*
* */
export const xieSchoolList = ( page, list_rows, org_name,  u_token = store.state.token2) => post("/org/xieSchoolList", {
   page, list_rows, org_name,  u_token
})

/*
* 教学协调中心 -机构班级列表
*
* */
export const xieClassList = ( page, list_rows, org_id,  u_token = store.state.token2) => post("/org/xieClassList", {
  page, list_rows, org_id,  u_token
})

/*
* 教学协调中心 -机构学生列表
*
* */
export const xieSchoolStuList = ( page, list_rows, org_id,class_id, stu_name, u_token = store.state.token2) => post("/org/xieSchoolStuList", {
  page, list_rows, org_id,class_id, stu_name,  u_token
})

/*
* 订单对比
*
* */
export const orgOrderList = (page,list_rows,student_name,exam_id,u_token = store.state.token2) => post("/org/orgOrderList", {
  page,list_rows,student_name,exam_id,u_token
})